/*
 *
 * DivisionEdit reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_DIVISION_WATCHER,
  GET_DIVISION_SUCCESS,
  GET_DIVISION_FAILED,
  GET_DIVISION_PARENTS_WATCHER,
  GET_DIVISION_PARENTS_SUCCESS,
  GET_DIVISION_PARENTS_FAILED,
  GET_SUBDIVISIONS_WIHOUT_PARENT_WATCHER,
  GET_SUBDIVISIONS_WIHOUT_PARENT_SUCCESS,
  GET_SUBDIVISIONS_WIHOUT_PARENT_FAILED,
  DELETE_DIVISION_WATCHER,
  DELETE_DIVISION_SUCCESS,
  DELETE_DIVISION_FAILED,
  GET_CHILDREN_DIVISION_WATCHER,
  GET_CHILDREN_DIVISION_SUCCESS,
  GET_CHILDREN_DIVISION_FAILED,
  DELETE_SUBDIVISION_WATCHER,
  DELETE_SUBDIVISION_SUCCESS,
  DELETE_SUBDIVISION_FAILED,
  GET_COLLABORATORS_DIVISION_WATCHER,
  GET_COLLABORATORS_DIVISION_SUCCESS,
  GET_COLLABORATORS_DIVISION_FAILED,
  UPDATE_NAME_DIVISION_FAILED,
  ADD_SUBDIVISION_WATCHER,
  ADD_SUBDIVISION_SUCCESS,
  ADD_SUBDIVISION_FAILED,
  UP_LEVEL_ONE_WATCHER,
  GET_EMPLOYEES_DIVISIONS_FAILED,
  GET_EMPLOYEES_DIVISIONS_SUCCESS,
  GET_EMPLOYEES_DIVISIONS_WATCHER,
  GET_HISTORY_WATCHER,
  GET_HISTORY_SUCCESS,
  GET_HISTORY_FAILED,
  GET_LANGUAGE_WATCHER,
  GET_LANGUAGE_SUCCESS,
  GET_LANGUAGE_FAILED,
} from "./constants"

export const initialState = fromJS({
  division: {},
  divisionParents: [],
  subdivisionsWithoutParent: [],
  childrenDivision: [],
  collaboratorsDivision: [],
  isLoadingDivision: true,
  isLoadingDivisionParents: true,
  isLoadingSubdivisionsWihoutParent: true,
  isRemovingDivision: true,
  isRemovingSubdivision: true,
  isLoadingChildrenDivision: true,
  isLoadingCollaboratorsDivision: true,
  messageErrorUpdateName: "",
  messageDeleteSubdivision: "",
  listEmployees: [],
  listDivisions: [],
  history: [],
  isLoadingHistory: false,
  isLoadingLanguage: true,
  languages: [],
})

function divisionEditReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LANGUAGE_WATCHER:
      return state.set("isLoadingLanguage", true)
    case GET_LANGUAGE_SUCCESS:
      return state
        .set("languages", action.payload)
        .set("isLoadingLanguage", false)
    case GET_LANGUAGE_FAILED:
      return state.set("isLoadingLanguage", false).set("languages", [])
    case GET_HISTORY_WATCHER:
      return state.set("isLoadingHistory", true)
    // .set('history', []);
    case GET_HISTORY_SUCCESS:
      return state.set("isLoadingHistory", false).set("history", action.payload)
    case GET_HISTORY_FAILED:
      return state.set("isLoadingHistory", false).set("history", [])

    case GET_DIVISION_WATCHER:
      return state.set("isLoadingDivision", true)
    case GET_DIVISION_SUCCESS:
      return state
        .set("isLoadingDivision", false)
        .set("division", action.payload)
    case GET_DIVISION_FAILED:
      return state.set("isLoadingDivision", false).set("division", {})

    case GET_CHILDREN_DIVISION_WATCHER:
      return state.set("isLoadingChildrenDivision", true)
    case GET_CHILDREN_DIVISION_SUCCESS:
      return state
        .set("isLoadingChildrenDivision", false)
        .set("childrenDivision", action.payload)
    case GET_CHILDREN_DIVISION_FAILED:
      return state
        .set("isLoadingChildrenDivision", false)
        .set("childrenDivision", [])

    case GET_DIVISION_PARENTS_WATCHER:
      return state.set("isLoadingDivisionParents", true)
    case GET_DIVISION_PARENTS_SUCCESS:
      return state
        .set("isLoadingDivisionParents", false)
        .set("divisionParents", action.payload)
    case GET_DIVISION_PARENTS_FAILED:
      return state
        .set("isLoadingDivisionParents", false)
        .set("divisionParents", [])

    case GET_SUBDIVISIONS_WIHOUT_PARENT_WATCHER:
      return state.set("isLoadingSubdivisionsWihoutParent", true)
    case GET_SUBDIVISIONS_WIHOUT_PARENT_SUCCESS:
      return state
        .set("isLoadingSubdivisionsWihoutParent", false)
        .set("subdivisionsWithoutParent", action.payload)
    case GET_SUBDIVISIONS_WIHOUT_PARENT_FAILED:
      return state
        .set("isLoadingSubdivisionsWihoutParent", false)
        .set("subdivisionsWithoutParent", [])

    case DELETE_DIVISION_WATCHER:
      return state.set("isRemovingDivision", true)
    case DELETE_DIVISION_SUCCESS:
      return state.set("isRemovingDivision", false)
    case DELETE_DIVISION_FAILED:
      return state.set("isRemovingDivision", false)

    case DELETE_SUBDIVISION_WATCHER:
      return state
        .set("isRemovingSubdivision", true)
        .set("isLoadingChildrenDivision", true)
        .set("messageDeleteSubdivision", "")
    case DELETE_SUBDIVISION_SUCCESS:
      return state
        .set("isRemovingSubdivision", false)
        .set("isLoadingChildrenDivision", false)
        .set("messageDeleteSubdivision", action.payload)
    case DELETE_SUBDIVISION_FAILED:
      return state
        .set("isRemovingSubdivision", false)
        .set("isLoadingChildrenDivision", false)
        .set("messageDeleteSubdivision", action.payload)

    case ADD_SUBDIVISION_WATCHER:
      return state.set("isLoadingChildrenDivision", true)
    case ADD_SUBDIVISION_SUCCESS:
      return state.set("isLoadingChildrenDivision", false)
    case ADD_SUBDIVISION_FAILED:
      return state.set("isLoadingChildrenDivision", false)

    case GET_COLLABORATORS_DIVISION_WATCHER:
      return state.set("isLoadingCollaboratorsDivision", true)
    case GET_COLLABORATORS_DIVISION_SUCCESS:
      return state
        .set("isLoadingCollaboratorsDivision", false)
        .set("collaboratorsDivision", action.payload)
    case GET_COLLABORATORS_DIVISION_FAILED:
      return state
        .set("isLoadingCollaboratorsDivision", false)
        .set("collaboratorsDivision", [])

    case UPDATE_NAME_DIVISION_FAILED:
      return state.set("messageErrorUpdateName", action.payload)

    case UP_LEVEL_ONE_WATCHER:
      return state.set("isLoadingDivision", true)

    case GET_EMPLOYEES_DIVISIONS_WATCHER:
      return state.set("isLoadingDetails", true)
    case GET_EMPLOYEES_DIVISIONS_SUCCESS:
      return state
        .set("listEmployees", action.payload.employees)
        .set("listDivisions", action.payload.divisions)
        .set("isLoadingDetails", false)
    case GET_EMPLOYEES_DIVISIONS_FAILED:
      return state
        .set("listEmployees", [])
        .set("listDivisions", [])
        .set("isLoadingDetails", false)

    default:
      return state
  }
}

export default divisionEditReducer
